const { isChoiceEligible } = require('../experiments/choiceExpansion');

const isFiverrChoice = (params, abTests, choiceEligibilities) => {
    if (!params.fiverr_choice) {
        return false;
    }

    return isChoiceEligible(abTests, choiceEligibilities);
};

module.exports = {
    isFiverrChoice
};
